import { AnimatePresence, motion } from 'framer-motion';
import { Outlet, useLocation } from 'react-router';
import { unifiedNavigation } from '@/config/modules';
import { AppLayout } from './app-layout';

export function MainLayout() {
  const location = useLocation();

  return (
    <AppLayout navigation={unifiedNavigation}>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.15 }}
          className="h-full"
        >
          <Outlet />
        </motion.div>
      </AnimatePresence>
    </AppLayout>
  );
}
